import { View } from "react-native";

const KeyboardManager = {
  setToolbarPreviousNextButtonEnable: (): void => {},
};

export default KeyboardManager;

export const PreviousNextView = View;
